import React from 'react';
import Breadcrumb from '../components/Breadcrumb';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../components/ui/accordion';
import { faqs } from '../mock';

const FAQs = () => {
  return (
    <div className="min-h-screen">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Breadcrumb items={[{ label: 'FAQs', path: '/faqs' }]} />

        {/* Header */}
        <div className="mb-12">
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-6">Frequently Asked Questions</h1>
          <p className="text-xl text-gray-300">
            Common questions about options, risks, taxes, and strategies—answered clearly and honestly.
          </p>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-4">
          {faqs.map((faq) => (
            <AccordionItem
              key={faq.id}
              value={`item-${faq.id}`}
              className="bg-gray-900/50 border border-gray-800 rounded-lg px-6 data-[state=open]:border-emerald-800"
            >
              <AccordionTrigger className="text-left text-white hover:text-emerald-400 py-4">
                {faq.question}
              </AccordionTrigger>
              <AccordionContent className="text-gray-300 pb-4 leading-relaxed">
                {faq.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>

        {/* Still Have Questions */}
        <div className="mt-16 glass rounded-xl p-8 text-center">
          <h2 className="text-2xl font-bold text-white mb-4">Still have questions?</h2>
          <p className="text-gray-300 mb-6">
            Remember: This is educational content only. For personalized advice, consult a qualified financial professional.
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQs;